import React, { useEffect, useState } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Modal,
  ModalBody,
  Button,
} from 'reactstrap';
import COBRE from './../../assets/images/Cremacion/anforas/COBRE.jpg';
import CIPRES_CAOBA from './../../assets/images/Cremacion/anforas/COFRE_PINO_CAOBA.png';
import CIPRES_ROBLE from './../../assets/images/Cremacion/anforas/CIPRES_CAOBA.jpg';
import PAULOWNIA from './../../assets/images/Cremacion/anforas/PAULOWNIA.jpg';
import PLATA from './../../assets/images/Cremacion/anforas/PLATA.jpg';
import ARBOL_DE_VIDA from './../../assets/images/Cremacion/anforas/ARBOL_DE_VIDA.jpg';
import ARAYAN from './../../assets/images/Cremacion/anforas/CIPRES_ARAYAN.jpg';
import BIOS from './../../assets/images/Cremacion/anforas/BIOS.jpg';
import NU from './../../assets/images/Cremacion/anforas/NU.jpg';
import ARENAE from './../../assets/images/Cremacion/anforas/ARENAE.jpg';
import SAMSARA from './../../assets/images/Cremacion/anforas/SAMSARA.jpg';
import MADRE_PERLA from './../../assets/images/Cremacion/anforas/MADRE_PERLA.jpg';
import ONYX_GRECO from './../../assets/images/Cremacion/anforas/ONYX_GRECO.jpg';

import SUPERIOR_ROYAL_BIRD from './../../assets/images/Cremacion/anforas/SUPERIOR_ROYAL_BIRD.jpeg';
import ANFORA_DORADA_FINAL from './../../assets/images/Cremacion/anforas/anfora_dorada_final.jpg';

import ANFORA_GOLD_LOVE from './../../assets/images/Cremacion/anforas/2022/Anfora_Gold_Love.png';
import ANFORA_ARBOL_DE_VIDA from './../../assets/images/Cremacion/anforas/2022/Anfora_Arbol_De_Vida.png';
import ANFORA_ROYAL_BIRD from './../../assets/images/Cremacion/anforas/2022/Anfora_Royal_Bird.png';

import ANFORA_MADERA_PERLA from './../../assets/images/Cremacion/anforas/2022/anfora_madera_perla.png';
import ANFORA_2023_ROYAL_BIRD from './../../assets/images/Cremacion/anforas/2023/anfora_royal_bird.png';
import ModalRender from './ModalRender';
import M from 'minimatch';

import ANFORA_ONYX_GRECO_350_350 from './../../assets/images/Cremacion/anforas/2023/onyx_350_350.png';

import ANFORA_SILVER_BIRD from './../../assets/images/Cremacion/anforas/2024/silver_350_350.png';

const anforas = [
  {
    category: 'Estándar',
    products: [
      // {
      //     "name": "Ánfora Gold Love",
      //     "stock": "",
      //     "disponible": "",
      //     "image": ANFORA_GOLD_LOVE,
      // },
      // {
      //     "name": "Ánfora Árbol de Vida",
      //     "stock": "",
      //     "disponible": "",
      //     "image": ANFORA_ARBOL_DE_VIDA,
      // },
      // {
      //     "name": "Ánfora Royal Bird",
      //     "stock": "",
      //     "disponible": "",
      //     "image": ANFORA_ROYAL_BIRD,
      // }
      {
        id: 1,
        open: false,
        name: 'Ánfora Clásica de Cobre',
        stock: '',
        disponible: '',
        image: COBRE,
        material: 'Cobre.',
        sugerencia: 'Resguardo en el hogar, Columbarios y Traslados.',
      },
      {
        id: 2,
        open: false,
        name: 'Cofre Pino Caoba',
        stock: '',
        disponible: '',
        image: CIPRES_CAOBA,
        material: 'Madera pino con terminación en tintes naturales Caoba.',
        sugerencia: 'Resguardo en el hogar y Traslados.',
      },
      // {
      //     "name": "Cofre Pino Roble",
      //     "stock": "",
      //     "disponible": "",
      //     "image": CIPRES_ROBLE,
      // }
      {
        id: 3,
        open: false,
        name: 'Ánfora Dorada',
        stock: '',
        disponible: '',
        image: ANFORA_DORADA_FINAL,
        material:
          'Aleación de Aluminio terminación en tintes naturales de Roble.',
        sugerencia: 'Resguardo en el hogar y Traslados.',
      },
    ],
  },
  {
    category: 'Especial',
    products: [
      {
        id: 4,
        open: false,
        name: 'Ánfora Pawlonia',
        stock: '',
        disponible: '',
        image: PAULOWNIA,
        material: 'Madera.',
        sugerencia: 'Resguardo en el hogar, Columbarios y Traslados.',
      },
      {
        id: 5,
        open: false,
        name: 'Cofre Arayan',
        stock: '',
        disponible: '',
        image: ARAYAN,
        material: 'Madera.',
        sugerencia: 'Resguardo en el hogar y Traslados.',
      },
      {
        id: 6,
        open: false,
        name: 'Ánfora Plata',
        stock: '',
        disponible: '',
        image: PLATA,
        material: 'Bronce.',
        sugerencia: 'Resguardo en el hogar, Columbarios y Traslados.',
      },
      {
        name: 'Ánfora Silver Bird',
        stock: '',
        disponible: '',
        image: ANFORA_SILVER_BIRD,
      },
    ],
  },
  {
    category: 'Superior',
    products: [
      // ,
      // {
      //     "name": "Ánfora Royal Bird",
      //     "stock": "",
      //     "disponible": "",
      //     //"image": ARBOL_DE_VIDA,
      //     "image": SUPERIOR_ROYAL_BIRD,
      // },
      // {
      //     "name": "Ánfora Madre Perla",
      //     "stock": "",
      //     "disponible": "",
      //     "image": MADRE_PERLA,
      // },
      // {
      //     "name": "Ánfora Onyx Greco",
      //     "stock": "",
      //     "disponible": "",
      //     "image": ONYX_GRECO,
      // // }
      // {
      // <<<<<<< HEAD
      //         id: 7,
      //         open: false,
      //         name: 'Ánfora Gold Love',
      //         stock: '',
      //         disponible: '',
      //         image: ANFORA_GOLD_LOVE,
      //         material: 'Bronce.',
      //         sugerencia: 'Resguardo en el hogar, Columbarios y Traslados.',
      // =======
      {
        id: 15,
        open: false,
        name: 'Onyx Greco',
        stock: '',
        disponible: '',
        material: '',
        sugerencia: '',
        image: ANFORA_ONYX_GRECO_350_350,
      },
      // {
      //   name: 'Ánfora Gold Love',
      //   stock: '',
      //   disponible: '',
      //   image: ANFORA_GOLD_LOVE,
      // },
      {
        id: 8,
        open: false,
        name: 'Ánfora Árbol de Vida',
        stock: '',
        disponible: '',
        image: ANFORA_ARBOL_DE_VIDA,
        material: 'Bronce.',
        sugerencia: 'Resguardo en el hogar, Columbarios y Traslados.',
      },
      // {
      //     "name": "Ánfora Royal Bird",
      //     "stock": "",
      //     "disponible": "",
      //     "image": ANFORA_ROYAL_BIRD,
      // }
      {
        id: 9,
        open: false,
        name: 'Ánfora Royal Bird',
        stock: '',
        disponible: '',
        image: ANFORA_2023_ROYAL_BIRD,
        material: 'Bronce.',
        sugerencia: 'Resguardo en el hogar, Columbarios y Traslados.',
      },
    ],
  },
  {
    category: 'Madre Tierra',
    products: [
      {
        id: 10,
        open: false,
        name: 'Ánfora Bios',
        stock: '',
        disponible: '',
        image: BIOS,
        material: 'Pulpa de papel.',
        sugerencia: 'Plantar.',
      },
      {
        id: 11,
        open: false,
        name: 'Ánfora Nu',
        stock: '',
        disponible: '',
        image: NU,
        material: 'Sal y aglutinantes naturales.',
        sugerencia: 'Dispersión agua salada.',
      },
      {
        id: 12,
        open: false,
        name: 'Ánfora Arenae',
        stock: '',
        disponible: '',
        image: ARENAE,
        material: 'Arena y aglutinantes naturales.',
        sugerencia: 'Dispersión agua salada o dulce.',
      },
      {
        id: 13,
        open: false,
        name: 'Ánfora Samsara',
        stock: '',
        disponible: '',
        image: SAMSARA,
        material: 'Arena y aglutinantes naturales.',
        sugerencia: 'Dispersión agua salada o dulce.',
      },
    ],
  },
];

const Anforas = () => {
  const [statusTab, setStatusTab] = useState(0);
  const [item, setItem] = useState({});
  const [openmodal, setOpenModal] = useState(false);

  const toggle = (index) => {
    setStatusTab(index);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleClickModal = (value) => {
    setOpenModal(true);
    setItem(value);
  };

  const closeModal = () => {
    setOpenModal(false);
  };
  return (
    <>
      {openmodal === true && (
        <ModalRender open={openmodal} anfora={item} setOpenModal={closeModal} />
      )}

      <div className="row my-5">
        <div className="col-12 text-center">
          <h2>
            Descubre nuestra gran <strong>variedad de ánforas</strong>
          </h2>
          <p>
            Contamos con diferentes categorías de ánforas, para entregar una
            opción para cada tipo de familia. Desde la más tradicional y
            sencilla, hasta las más modernas y ecológicas.
          </p>
        </div>
      </div>
      <div className="tab-anforas">
        <Nav tabs>
          {anforas.map((val, index) => (
            <NavItem>
              <NavLink
                onClick={() => {
                  toggle(index);
                }}
              >
                {val.category}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        <TabContent activeTab={statusTab}>
          {anforas.map((val, index) => (
            <TabPane tabId={index}>
              <div className="row my-4">
                {val.products.map((value, key) => (
                  <div className="col-12 col-md-3 px-2 text-center" key={key}>
                    <div className="box mb-2">
                      <div className="box__title_anfora">
                        <p>{value.name}</p>
                      </div>
                      <div className="box__content p-2">
                        <img
                          src={value.image}
                          alt=""
                          className="img-fluid mb-2 image"
                          style={{ cursor: 'pointer' }}
                          onClick={(e) => {
                            handleClickModal(value);
                          }}
                        />
                        {/* <p className="mb-2">
                          <strong>{value.name}</strong>
                        </p> */}
                        <p className="description">{value.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </TabPane>
          ))}
        </TabContent>
      </div>
    </>
  );
};
export default Anforas;
